<template>
  <div class="status-page">

    <!-- Header -->
    <div class="page-header">
      <h1 class="page-title">Statuts de l'Association</h1>
      <div class="page-title-bar"></div>
      <p class="page-subtitle">Extrait des statuts officiels de SELIDAIRE</p>
    </div>

    <v-container class="status-container">

      <!-- Article 1 -->
      <v-card class="article-block" elevation="1" rounded="lg">
        <div class="article-number">Article 1</div>
        <div class="article-body">
          <p>
            Il est créé entre les adhérents aux présents statuts une association régie par la loi du
            <strong>1er juillet 1901</strong> et le décret du 16 août 1901, ayant pour dénomination :
          </p>
          <div class="association-name">
            <div class="name-main">SELIDAIRE</div>
            <div class="name-sub">Association de Défense des Intérêts des Propriétaires de Varangéville et Environs</div>
          </div>
        </div>
      </v-card>

      <!-- Article 2 -->
      <v-card class="article-block" elevation="1" rounded="lg">
        <div class="article-number">Article 2</div>
        <div class="article-body">
          <p>
            Cette association a pour principal but de regrouper en son sein l'ensemble des propriétaires
            des maisons et lieux d'habitations situés sur les territoires des communes concernées par
            l'exploitation de la mine de sel par galeries et piliers, concédée à ce jour à la
            Compagnie des Salins du Midi et Salines de l'Est.
          </p>
          <p>
            Ces propriétaires sont aujourd'hui préoccupés par les risques miniers engendrés par
            l'activité minière d'hier et d'aujourd'hui sous ou dans le voisinage de leurs maisons
            ou lieux d'habitation. Cette association regroupera également les propriétaires de biens
            fonciers non bâtis situés au-dessus ou dans le voisinage du même édifice minier.
          </p>

          <div class="objectives-title">
            <v-icon size="18">mdi-target</v-icon>
            Objectifs de l'association
          </div>

          <div class="objective-item">
            <div class="objective-bullet">01</div>
            <p>
              Demander collectivement en justice la constitution de la caution prévue par
              l'<strong>article 74 du code minier</strong>. Cet objectif a pour corollaire
              l'intervention de l'association en justice en cas de dommages sur les propriétés
              de ses adhérents pour exiger le paiement aux propriétaires des sommes cautionnées.
            </p>
          </div>

          <div class="objective-item">
            <div class="objective-bullet">02</div>
            <p>
              Pour les propriétés non concernées par l'article 74, soutenir en justice toutes
              actions visant à obtenir des responsables d'éventuels dégâts, dégradations ou
              dépréciations le versement d'indemnités compensatrices aux pertes des valeurs
              vénales des biens concernés.
            </p>
          </div>

          <div class="objective-item">
            <div class="objective-bullet">03</div>
            <p>
              Participer et encourager toutes actions susceptibles de conduire à la diminution
              voire la suppression du risque minier, et devenir un partenaire incontournable
              des organismes publics ou privés travaillant sur le devenir de la mine.
            </p>
          </div>
        </div>
      </v-card>

    </v-container>
  </div>
</template>

<style scoped>
.status-page {
  background: #fafafa;
  min-height: 100vh;
}

.page-header {
  padding: 32px 24px 20px;
  background: #ffffff;
  border-bottom: 1px solid #e0e0e0;
  text-align: center;
}

.page-title {
  font-size: 1.4rem;
  font-weight: 700;
  color: #212121;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  margin-bottom: 10px;
}

.page-title-bar {
  width: 40px;
  height: 3px;
  background: #E65100;
  margin: 0 auto 12px;
  border-radius: 2px;
}

.page-subtitle {
  font-size: 0.85rem;
  color: #757575;
  margin: 0;
}

.status-container {
  max-width: 780px;
  padding-top: 28px;
  padding-bottom: 48px;
}

.article-block {
  margin-bottom: 20px;
  overflow: hidden;
}

.article-number {
  background: #E65100;
  color: white;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  padding: 8px 20px;
}

.article-body {
  padding: 20px 24px;
}

.article-body p {
  font-size: 0.9rem;
  color: #424242;
  line-height: 1.8;
  margin-bottom: 14px;
  text-align: justify;
}

.association-name {
  background: #FFF3E0;
  border-left: 4px solid #E65100;
  border-radius: 6px;
  padding: 14px 20px;
  margin: 16px 0;
  text-align: center;
}

.name-main {
  font-size: 1.2rem;
  font-weight: 800;
  letter-spacing: 0.15em;
  color: #BF360C;
  margin-bottom: 4px;
}

.name-sub {
  font-size: 0.82rem;
  color: #555;
  font-style: italic;
}

.objectives-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.82rem;
  font-weight: 700;
  color: #E65100;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  margin: 20px 0 16px;
}

.objective-item {
  display: flex;
  gap: 16px;
  align-items: flex-start;
  margin-bottom: 16px;
}

.objective-bullet {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  background: #E65100;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.7rem;
  font-weight: 700;
  margin-top: 2px;
}

.objective-item p {
  margin: 0;
}
</style>
